import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const opdTariffApi = {
  get: () => axios
    .get(`${API}/api/tenant-admin/opd-tariff`, { withCredentials: true })
    .then((r) => r.data),
  update: (body) => axios
    .patch(`${API}/api/tenant-admin/opd-tariff`, body, { withCredentials: true })
    .then((r) => r.data),
};
